import React from "react";
import { useRef } from "react";
import { Form, Divider, Input, DatePicker, Button, Upload } from 'antd';
import { UploadOutlined, PlusOutlined, DeleteOutlined } from "@ant-design/icons";
const { TextArea } = Input;


const TechnicalOffers = () => {
    const technicalOfferAddButtonRef = useRef(null);
    return (
        <div className="col-lg-12 col-md-12">
            <Form.List name="technical_offers">
                {(technicalOffers, { add, remove }) => {
                    if (technicalOffers.length == 0 && technicalOfferAddButtonRef.current) {
                        technicalOfferAddButtonRef.current.click();
                    }
                    return (
                        <div>
                            {technicalOffers.map((field, index) =>
                                <div key={field.key} className="row">

                                    {technicalOffers.length > 1 &&
                                        (<div className="col-lg-12 col-md-12" style={{ display: 'flex', justifyContent: "space-between", alignItems: "center", background: "#d3d3d34a", marginBottom: "15px" }}>
                                            <div>
                                                #{index + 1}
                                            </div>
                                            {technicalOffers.length > 1 &&
                                                <Button
                                                    type="link"
                                                    className="dynamic-delete-button"
                                                    onClick={() => { remove(field.name) }}
                                                    icon={<DeleteOutlined style={{ color: "red" }} />}
                                                >
                                                </Button>
                                            }
                                        </div>)}
                                    <div className="col-lg-6 col-md-12">
                                        <Form.Item
                                            name={[index, "vendor"]}
                                            label="Vendor"
                                            rules={[{ required: true, message: "Please enter Vendor" }]}>
                                            <Input placeholder="Enter Vendor" />
                                        </Form.Item>
                                    </div>
                                    <div className="col-lg-6 col-md-12">
                                        <Form.Item
                                            name={[index, "file_upload"]}
                                            label="Offer"
                                            rules={[{ required: true, message: "Please enter PR Number" }]}>
                                            <Upload >
                                                <Button icon={<UploadOutlined />}>Click to Upload</Button>
                                            </Upload>
                                        </Form.Item>
                                    </div>

                                </div>
                            )}
                            <Divider />
                            <div className="row">
                                <div className="col-lg-12 col-md-12" style={{textAlign: "right"}}>
                                    <Form.Item>
                                        <Button
                                            ref={technicalOfferAddButtonRef}
                                            type="primary"
                                            onClick={() => add()}
                                        >
                                            <PlusOutlined />
                                            {technicalOffers.length > 0 ? "Add more" : "Add"}
                                        </Button>
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                    );
                }}
            </Form.List>
        </div>
    )
}

export default TechnicalOffers;